/**
 * @flow
 * @relayHash 3c2a81f5719cda0d36e4b1f97d33f8ca
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CollectionItemDeleteInput = {|
  id: string,
  clientMutationId?: ?string,
  revisionMessage?: ?string,
|};
export type CollectionItemDeleteMutationVariables = {|
  input: CollectionItemDeleteInput
|};
export type CollectionItemDeleteMutationResponse = {|
  +collectionItemDelete: ?{|
    +deletedId: string,
    +lifeNode: ?{|
      +id: string,
      +collectionList: ?{|
        +totalCount: ?number
      |},
      +myCollectionItem: ?{|
        +id: string
      |},
    |},
    +errors: ?$ReadOnlyArray<?{|
      +code: ?string,
      +location: ?string,
      +message: string,
    |}>,
  |}
|};
export type CollectionItemDeleteMutation = {|
  variables: CollectionItemDeleteMutationVariables,
  response: CollectionItemDeleteMutationResponse,
|};
*/


/*
mutation CollectionItemDeleteMutation(
  $input: CollectionItemDeleteInput!
) {
  collectionItemDelete(input: $input) {
    deletedId
    lifeNode {
      id
      collectionList {
        totalCount
      }
      myCollectionItem {
        id
      }
    }
    errors {
      code
      location
      message
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CollectionItemDeleteInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "collectionItemDelete",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CollectionItemDeletePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "lifeNode",
        "storageKey": null,
        "args": null,
        "concreteType": "LifeNode",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "collectionList",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionItemConnection",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalCount",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "myCollectionItem",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionItem",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "Error",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "code",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CollectionItemDeleteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CollectionItemDeleteMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CollectionItemDeleteMutation",
    "id": null,
    "text": "mutation CollectionItemDeleteMutation(\n  $input: CollectionItemDeleteInput!\n) {\n  collectionItemDelete(input: $input) {\n    deletedId\n    lifeNode {\n      id\n      collectionList {\n        totalCount\n      }\n      myCollectionItem {\n        id\n      }\n    }\n    errors {\n      code\n      location\n      message\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '266e5004f75d6121d3cec71d46eaeec8';
module.exports = node;
